var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#5E4635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 30.75C41.7485 29.3581 41.1949 28.0236 40.2107 27.0393C39.2264 26.0551 37.8919 25.5015 36.5 25.5H32.75C32.75 24.9033 32.9871 24.331 33.409 23.909C33.831 23.4871 34.4033 23.25 35 23.25C35.1989 23.25 35.3897 23.171 35.5303 23.0303C35.671 22.8897 35.75 22.6989 35.75 22.5C35.75 22.3011 35.671 22.1103 35.5303 21.9697C35.3897 21.829 35.1989 21.75 35 21.75C34.0054 21.75 33.0516 22.1451 32.3483 22.8483C31.6451 23.5516 31.25 24.5054 31.25 25.5H27.5C26.1081 25.5015 24.7736 26.0551 23.7893 27.0393C22.8051 28.0236 22.2515 29.3581 22.25 30.75C22.2503 31.013 22.3197 31.2714 22.4513 31.4991C22.583 31.7269 22.7722 31.916 23 32.0475V33C23 36.3309 26.105 38.8237 28.6006 40.8272C29.7181 41.7253 31.25 42.9544 31.25 43.5C31.25 43.6989 31.329 43.8897 31.4697 44.0303C31.6103 44.171 31.8011 44.25 32 44.25C32.1989 44.25 32.3897 44.171 32.5303 44.0303C32.671 43.8897 32.75 43.6989 32.75 43.5C32.75 42.9544 34.2819 41.7253 35.3994 40.8272C37.895 38.8237 41 36.3309 41 33V32.0475C41.2278 31.916 41.417 31.7269 41.5487 31.4991C41.6803 31.2714 41.7497 31.013 41.75 30.75ZM34.4609 39.6562C33.4653 40.455 32.5859 41.1562 32 41.8472C31.4141 41.1609 30.5347 40.455 29.5391 39.6562C27.2937 37.8553 24.5 35.6119 24.5 33V32.25H39.5V33C39.5 35.6119 36.7063 37.8553 34.4609 39.6562Z",
    fill: "#F0E9E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcorn);
export default __webpack_public_path__ + "static/media/acorn.476709a388cce723ea7447bb5ddb35d6.svg";
export { ForwardRef as ReactComponent };